import type { CoveredRange } from "./covered-range";

/**
 * Add `incoming` to a range list and return a new sorted + coalesced list.
 * Does not mutate `existing` or `incoming`.
 *
 * Touching ranges (`last.endMs === next.startMs`) are merged — contiguous coverage
 * has no seam. `existing` need not be pre-sorted; the whole set is re-sorted.
 */
export function mergeCoveredRanges(existing: CoveredRange[], incoming: CoveredRange): CoveredRange[] {
    const sorted = [...existing, incoming].sort((a, b) => a.startMs - b.startMs);
    return sorted.reduce<CoveredRange[]>((acc, range) => {
        const last = acc[acc.length - 1];
        if (last && last.endMs >= range.startMs) {
            // Overlap or touch — extend the last range. `last` is already a fresh
            // copy in `acc`, so this never mutates an input range.
            last.endMs = Math.max(last.endMs, range.endMs);
            return acc;
        }
        acc.push({ ...range });
        return acc;
    }, []);
}
